import { computed, ref } from 'vue'

type ThemeMode = 'dark' | 'light'

const STORAGE_KEY = 'rattil-theme'
const DARK_CLASS = 'theme-dark'
const LIGHT_CLASS = 'theme-light'

const theme = ref<ThemeMode>('dark')

const applyThemeClass = (mode: ThemeMode) => {
  if (typeof document === 'undefined') return

  const root = document.documentElement
  root.classList.remove(DARK_CLASS, LIGHT_CLASS)
  root.classList.add(mode === 'dark' ? DARK_CLASS : LIGHT_CLASS)
  root.style.colorScheme = mode
}

export const initTheme = () => {
  if (typeof window === 'undefined') return

  const saved = window.localStorage.getItem(STORAGE_KEY)
  if (saved === 'dark' || saved === 'light') {
    theme.value = saved
  } else {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    theme.value = prefersDark ? 'dark' : 'light'
  }

  applyThemeClass(theme.value)
}

export const useTheme = () => {
  const setTheme = (mode: ThemeMode) => {
    theme.value = mode
    applyThemeClass(mode)
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, mode)
    }
  }

  const toggleTheme = () => {
    setTheme(theme.value === 'dark' ? 'light' : 'dark')
  }

  return {
    theme: computed(() => theme.value),
    isDark: computed(() => theme.value === 'dark'),
    setTheme,
    toggleTheme,
  }
}
